import UploadImageNode from './UploadImageNode';
import UploadVideoNode from './UploadVideoNode';
import UploadAudioNode from './UploadAudioNode';
import ImageEnhancementNode from './ImageEnhancementNode';
import OutputPreviewNode from './OutputPreviewNode';
import VideoGenerationNode from './VideoGenerationNode';
import NanoBananaNode from './NanoBananaNode';
import BackgroundRemovalNode from './BackgroundRemovalNode';
import VideoWithSoundNode from './VideoWithSoundNode';
import FabricAvatarNode from './FabricAvatarNode';
import DreamActorNode from './DreamActorNode';
import Lyria2Node from './Lyria2Node';
import Qwen3TTSNode from './Qwen3TTSNode';
import StyleTransferNode from './StyleTransferNode';
import UpscaleNode from './UpscaleNode';
import KlingAvatarNode from './KlingAvatarNode';
import FrameExtractorNode from './FrameExtractorNode';
import Lyria3ProNode from './Lyria3ProNode';
import ImageEditNode from './ImageEditNode';
import Banana2ProNode from './Banana2ProNode';
import GenQRNode from './GenQRNode';
import Image4UltraNode from './Image4UltraNode';
import Seedance25Node from './Seedance25Node';
import PixverseV6Node from './PixverseV6Node';
import EleV2Node from './EleV2Node';
import ElTraductorNode from './ElTraductorNode';
import LipSyncNode from './LipSyncNode';
import MusicProNode from './MusicProNode';
import AvatarFastNode from './AvatarFastNode';
import CaptureFrameNode from './CaptureFrameNode';
import { withNodeTooltip } from './NodeTooltip';

// Rich hover-tooltips: every canvas node is wrapped so that after ~500ms
// of hover it reveals its description, credit cost, IO signature and
// usage examples (fed by /api/tools → tool_registry.py). This keeps the
// individual node components untouched.
export const nodeTypes = {
  uploadImage: withNodeTooltip(UploadImageNode, 'uploadImage'),
  uploadVideo: withNodeTooltip(UploadVideoNode, 'uploadVideo'),
  uploadAudio: withNodeTooltip(UploadAudioNode, 'uploadAudio'),
  imageEnhancement: withNodeTooltip(ImageEnhancementNode, 'imageEnhancement'),
  outputPreview: withNodeTooltip(OutputPreviewNode, 'outputPreview'),
  videoGeneration: withNodeTooltip(VideoGenerationNode, 'videoGeneration'),
  nanoBanana: withNodeTooltip(NanoBananaNode, 'nanoBanana'),
  bgRemoval: withNodeTooltip(BackgroundRemovalNode, 'bgRemoval'),
  videoWithSound: withNodeTooltip(VideoWithSoundNode, 'videoWithSound'),
  fabricAvatar: withNodeTooltip(FabricAvatarNode, 'fabricAvatar'),
  dreamActor: withNodeTooltip(DreamActorNode, 'dreamActor'),
  lyria2: withNodeTooltip(Lyria2Node, 'lyria2'),
  qwen3tts: withNodeTooltip(Qwen3TTSNode, 'qwen3tts'),
  styleTransfer: withNodeTooltip(StyleTransferNode, 'styleTransfer'),
  upscale: withNodeTooltip(UpscaleNode, 'upscale'),
  klingAvatar: withNodeTooltip(KlingAvatarNode, 'klingAvatar'),
  frameExtractor: withNodeTooltip(FrameExtractorNode, 'frameExtractor'),
  lyria3pro: withNodeTooltip(Lyria3ProNode, 'lyria3pro'),
  imageEdit: withNodeTooltip(ImageEditNode, 'imageEdit'),
  banana2pro: withNodeTooltip(Banana2ProNode, 'banana2pro'),
  genQR: withNodeTooltip(GenQRNode, 'genQR'),
  imagen4Ultra: withNodeTooltip(Image4UltraNode, 'imagen4Ultra'),
  seedance25: withNodeTooltip(Seedance25Node, 'seedance25'),
  pixverseV6: withNodeTooltip(PixverseV6Node, 'pixverseV6'),
  eleV2: withNodeTooltip(EleV2Node, 'eleV2'),
  elTraductor: withNodeTooltip(ElTraductorNode, 'elTraductor'),
  lipSync: withNodeTooltip(LipSyncNode, 'lipSync'),
  musicPro: withNodeTooltip(MusicProNode, 'musicPro'),
  avatarFast: withNodeTooltip(AvatarFastNode, 'avatarFast'),
  captureFrame: withNodeTooltip(CaptureFrameNode, 'captureFrame'),
};

export {
  UploadImageNode,
  UploadVideoNode,
  UploadAudioNode,
  ImageEnhancementNode,
  OutputPreviewNode,
  VideoGenerationNode,
  NanoBananaNode,
  BackgroundRemovalNode,
  VideoWithSoundNode,
  FabricAvatarNode,
  DreamActorNode,
  Lyria2Node,
  Qwen3TTSNode,
  StyleTransferNode,
  UpscaleNode,
  KlingAvatarNode,
  FrameExtractorNode,
  Lyria3ProNode,
  ImageEditNode,
  Banana2ProNode,
  GenQRNode,
  Image4UltraNode,
  Seedance25Node,
  PixverseV6Node,
  EleV2Node,
  ElTraductorNode,
  LipSyncNode,
  MusicProNode,
  AvatarFastNode,
};
